const notifyError = (dispatch, message) => {
  dispatch('notifications/notifyError', { message }, { root: true })
}

export default notifyError
